module.exports = __webpack_public_path__ + "img/detailone_title.b2209013.png";